import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@vwfs-bronson/bronson-react';
import { FormikProps, useFormikContext } from 'formik';
import { RequestInitialValues } from './initialValues';
import { canSubmitForm } from './utils';

export const SubmitButton = ({
    onSubmit,
}: {
    onSubmit: ({ isValid, dirty }: { isValid: boolean; dirty: boolean }) => void;
}) => {
    const { t } = useTranslation('translation');
    const { values, submitForm, validateForm, dirty, isValid, isSubmitting }: FormikProps<RequestInitialValues> =
        useFormikContext();
    const [isHidden, setIsHidden] = useState<boolean>(false);
    const isSubmitDisabled = useMemo(() => {
        return !isValid || isSubmitting;
    }, [isValid, isSubmitting]);

    useEffect(() => {
        setIsHidden(!canSubmitForm(values));
    }, [values.vehicleClaim.reparable]);

    if (isHidden) {
        return null;
    }

    return (
        <Button
            testId={'submit-button'}
            disabled={isSubmitDisabled}
            type="button"
            onClick={async (): Promise<void> => {
                const errors = await validateForm();
                const formIsValid = Object.keys(errors).length === 0;
                if (!dirty || !formIsValid) {
                    onSubmit({ dirty, isValid: formIsValid });
                    return;
                }
                await submitForm();
            }}
        >
            {t('editable-section-nav.send')}
        </Button>
    );
};
